import React from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';

import "./PartnerSupport.scss";

export default function PartnerSupport({ data, customData }) {
  const { accountName, support } = !customData ? data : customData;;
  
  return (
    <div className="partner-support-wrapper">
      <Container>
        <div className="partner-support-container">
          <h2>Let {accountName} Help...</h2>
          <div className="support-card-container">
            <ul>
              {support.map((item, index) => {
                return <SupportItem title={item.title} backgroundImageUrl={item.backgroundImageUrl} key={(`item${index}`)}/>
              })}
            </ul>
          </div>
        </div>
      </Container>
    </div>
  );
}

export function SupportItem(props) {
  return (
    <li className="support-card" style={{'--bg-image-url': `url(${props.backgroundImageUrl})`}}>
      <p>{props.title}</p>
    </li>
  );
}

PartnerSupport.propTypes = {
  data: PropTypes.object.isRequired,
  customData: PropTypes.object,
};

SupportItem.propTypes = {
  title: PropTypes.string.isRequired,
  backgroundImageUrl: PropTypes.string.isRequired,
};
